import type { FirmPayloadDto } from '../dto';
import type { FirmPayload } from '../models';

export function mapFirmPayloadToDto(payload: FirmPayload): FirmPayloadDto {
  return {
    name: payload.name,
    address: payload.address,
    phone: payload.phone,
    email: payload.email,
    contact_name: payload.contactName,
  };
}
